import { defineMessages } from "react-intl";
const messages = defineMessages({
    customSubtopicsLabel: {
        id: "app.aiDiscoverability.customSubtopics.label",
        defaultMessage: "Custom Subtopics:",
    },
    saveSubtopicsButton: {
        id: "app.aiDiscoverability.customSubtopics.saveSubtopics",
        defaultMessage: "Save Subtopics",
    },
    tabLocation: {
        id: "app.aiDiscoverability.customSubtopics.tab.location",
        defaultMessage: "Location",
    },
    tabAmenities: {
        id: "app.aiDiscoverability.customSubtopics.tab.amenities",
        defaultMessage: "Amenities",
    },
    tabCommute: {
        id: "app.aiDiscoverability.customSubtopics.tab.commute",
        defaultMessage: "Commute",
    },
    tabPriceLayout: {
        id: "app.aiDiscoverability.customSubtopics.tab.priceLayout",
        defaultMessage: "Price & Layout",
    },
    unsavedChanges: {
        id: "app.aiDiscoverability.customSubtopics.unsavedChanges",
        defaultMessage: "*{count} Unsaved {count, plural, one {change} other {changes}} made",
    },
    upgradeToPremiumTooltip: {
        id: "app.aiDiscoverability.customSubtopics.upgradeToPremium",
        defaultMessage: "Upgrade to Premium to customize your reports",
    },
    hasBeenRunTooltip: {
        id: "app.aiDiscoverability.customSubtopics.hasBeenRunTooltip",
        defaultMessage: "<bold>Unable to edit subtopics on a report that has already been run.</bold><br></br><br></br>To make changes, create a new report.",
    },
    warningTitle: {
        id: "app.aiDiscoverability.customSubtopics.warningTitle",
        defaultMessage: "Changes unavailable for a report that has been run",
    },
    warningDescription: {
        id: "app.aiDiscoverability.customSubtopics.warningDescription",
        defaultMessage: "To add and/or remove subtopics altogether a new report must be created. You can use this current report’s setup as a template for the new report.",
    },
    warningActionButton: {
        id: "app.aiDiscoverability.customSubtopics.warningActionButton",
        defaultMessage: "Create New Report",
    },
    warningDialogTitle: {
        id: "app.aiDiscoverability.customSubtopics.warningDialogTitle",
        defaultMessage: "Create a new report to make changes?",
    },
    warningDialogDescription: {
        id: "app.aiDiscoverability.customSubtopics.warningDialogDescription",
        defaultMessage: "Updating topics will require deactivating your current report and creating a new one with the updated topics. Your current report history stays unchanged and all future reports for this community will use the new set of topics.",
    },
    warningDialogConfirmButton: {
        id: "app.aiDiscoverability.customSubtopics.warningDialogConfirmButton",
        defaultMessage: "Create a new report",
    },
    createReportError: {
        id: "app.aiDiscoverability.customSubtopics.createReportError",
        defaultMessage: "The new report could not be created: {message}",
    },
    warningDialogCancelButton: {
        id: "app.aiDiscoverability.customSubtopics.warningDialogCancelButton",
        defaultMessage: "Cancel",
    },
    customSubtopicsInfoTooltip: {
        id: "app.aiDiscoverability.customSubtopics.infoTooltip",
        defaultMessage: "Add up to {max} custom subtopics to tailor what this report evaluates. They apply on the next run and help surface insights specific to your community.",
    },
});
export default messages;
